import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Button component
 */
const Button = ({ children, ...props }) => {
  const {
    className,
    type,

    // Styles.
    primary,
    link,
    outline,

    // Colors
    success,
    error,

    // Sizes
    block,
    small,
    large,
    action,

    // States
    loading,
    ...otherProps
  } = props;

  const classNames = classnames(
    'btn',
    {
      'btn-primary': primary,
      'btn-link': link,
      'btn-success': success,
      'btn-error': error,
      'btn-block': block,
      'btn-sm': small,
      'btn-lg': large,
      'btn-action': action,
      'btn-outline': outline,
      loading,
    },
    className,
  );

  return (
    <button {...otherProps} className={classNames} type={type}>
      {children}
    </button>
  );
};

Button.propTypes = {
  /** Primary content. */
  children: PropTypes.any,
  /** Additional classes. */
  className: PropTypes.string,
  /** A button can be formatted to show different levels of emphasis. */
  primary: PropTypes.bool,
  /** Style button as link element */
  link: PropTypes.bool,
  /** A button can hint towards a positive consequence. */
  success: PropTypes.bool,
  /** A button can hint towards a negative consequence. */
  error: PropTypes.bool,
  /** A button can take the width of its container. */
  block: PropTypes.bool,
  /** A button can have small size. */
  small: PropTypes.bool,
  /** A button can have large size. */
  large: PropTypes.bool,
  /** Description of prop "foo". */
  action: PropTypes.bool,
  /** A button can show a loading indicator. */
  loading: PropTypes.bool,
  /** A button type. */
  type: PropTypes.string,
};

Button.defaultProps = {
  children: '',
  className: '',
  type: 'button',
  primary: false,
  link: false,
  success: false,
  error: false,
  block: false,
  small: false,
  large: false,
  action: false,
  loading: false,
};

Button.Group = ({ children }) => (
  <div className="btn-group">
    {children}
  </div>
);

Button.Group.propTypes = {
  children: PropTypes.any.isRequired,
};

export { Button };
